import React from "react";


const AudioPlayer = ({ src, title }) => {
  const handleContextMenu = (e) => {
    e.preventDefault();
    alert("Downloading is disabled for this confidential audio.");
  };

  return (
    <div className="audio-player card">
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600 }}>{title}</div>
        <div style={{ color: "var(--muted)", fontSize: 13 }}>
          Confidential — streaming only
        </div>
      </div>

      <audio
        controls
        controlsList="nodownload noplaybackrate"
        onContextMenu={handleContextMenu}
        style={{ width: 250 }}
      >
        <source src={src} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default AudioPlayer;
